module.exports = __webpack_public_path__ + "img/4-9counterclaim.f008dac4.png";